import {
   userStart,
   userFailure,
   loginSuccess,
   loginFailure,
   logoutSuccess,
   updateUserSuccess,
   createUserSuccess,
} from "./userRedux"
import {
   orderStart,
   orderFailure,
   getOrderSuccess,
   createOrderSuccess,
} from "./orderRedux"
import { publicRequest, userRequest } from "../requestMethods"

export const login = async (user, dispatch) => {
   dispatch(userStart())
   try {
      const res = await publicRequest.post("/auth/login", user)
      dispatch(loginSuccess(res.data))
      return "success"
   } catch (err) {
      dispatch(loginFailure(err.response ? err.response.data : err.message))
      return err.response ? err.response.data : err.message
   }
}

export const logout = async (dispatch) => {
   dispatch(userStart())
   try {
      dispatch(logoutSuccess())
   } catch (err) {
      dispatch(loginFailure(err.response.data))
   }
}

export const updateUser = async (id, user, dispatch) => {
   dispatch(userStart())
   try {
      await userRequest.put(`/users/${id}`, user)
      dispatch(updateUserSuccess({ id, user }))
      return "success"
   } catch (err) {
      dispatch(userFailure(err.response.data))
      return err.response.data
   }
}

export const register = async (user, dispatch) => {
   dispatch(userStart())
   try {
      await userRequest.post("/auth/register", user)
      dispatch(createUserSuccess({ user }))
      return "success"
   } catch (err) {
      dispatch(userFailure(err.response.data))
      return err.response.data
   }
}

export const createOrder = async (order, dispatch, token) => {
   dispatch(orderStart())
   try {
      await userRequest.post("/orders", order, {
         headers: { Authorization: `Bearer ${token}` },
      })
      dispatch(createOrderSuccess({ order }))
      return "success"
   } catch (err) {
      dispatch(orderFailure(err.response.data))
      return err.response.data
   }
}

export const getOrders = async (userId, dispatch) => {
   dispatch(orderStart())
   try {
      const res = await publicRequest.get(`/orders/find/user/${userId}`)
      dispatch(getOrderSuccess(res.data))
      return "success"
   } catch (err) {
      dispatch(orderFailure(err.response.data))
      return err.response.data
   }
}
